<br>
<div class="col-lg-12 animated fadeIn">
  <h4 style="text-align: center;">
    <u>
      Formulario para Gestión de Novedades
      <!-- <app-navbar hidden (notiGlobal)="obtenerNoti($event)"></app-navbar> -->
    </u>
  </h4>
  <div class="jumbo"><!--jumbo-->
    <div>
      <br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <label for="cuit"> CUIT</label>
      &nbsp;
      <app-cuit-input [(ngModel)]="filtroCuit" name="filtroCuit" inputClass="form-chico" placeholder="CUIT.."></app-cuit-input>
      &nbsp;
      <select  [(ngModel)]="filtroCuit" name="filtroCuit" id="filtroCuit" class="form-chico">
        <option value="TODOS">TODOS</option>
        <option *ngFor="let cuits of dataSourceEmpresas" [ngValue]="cuits.cuit">{{ cuits.razon }} -{{cuits.deuda | currency:"$" }}</option>
      </select>
    </div>
    <div>
      &nbsp;
      <label for="seccional">SECCIONAL</label>
      &nbsp;
      <select name="select" class="form-chico">
        <option value="TODAS">TODAS</option>
        <option value="ROSARIO">ROSARIO</option> 
        <option value="BAHIA">BAHIA</option>
        <option value="NECOCHEA">NECOCHEA</option>
        <option value="OTRA">OTRA</option>
      </select>
      &nbsp;
      <label for="fechad">Fecha Desde</label>&nbsp;<input class="form-chico" [(ngModel)]="fechad" name="fechad" type="date">
      &nbsp;
      <label for="fechah">Fecha Hasta</label>&nbsp;<input class="form-chico" [(ngModel)]="fechah" name="fechah" type="date">
      &nbsp;
      <label for="status">Estado</label>
      &nbsp;
      <select class="form-chico" name="filtroEstado" [(ngModel)]="filtroEstado">
        <option selected value="TODOS">TODOS</option> 
        <option value="ACUERDO P/CARGAR">ACUERDO P/CARGAR</option>
        <option value="CONCURSO PREVENTIVO">CONCURSO PREVENTIVO</option>
        <option value="DEUDA">DEUDA</option> 
        <option value="INUBICABLES">INUBICABLES</option>
        <option value="PAGADO">PAGADO</option>
        <option value="SIN EMPLEADO / BAJA">SIN EMPLEADO / BAJA</option>
      </select>
      &nbsp;
      <button type="button" class="btn btn-danger" (click)="cargarGrid()"> CONSULTAR  <i *ngIf="loading" class="fa fa-spinner fa-spin fa-1x fa-fw"></i></button>
    </div>
    <br>
</div><!--cierra jumbotron-->
  <div style="text-align: center;">  
    <br>
    <button *ngIf="role === 'ADMIN' || role === 'DATAENTRY'" type="button" class="btn btn-danger" data-toggle="modal" data-target="#MODALINSERTAR"><img src="../../../../assets/img/newww.png" style="width: 40px; height: 40px;"> Insertar Novedad</button>
    <button [disabled]="(!dataSourceOpe) || (dataSourceOpe.data.length === 0)" type="button" class="btn btn-success" (click)="exportExcel2( dataSourceOpe.data )"><img src="../../../../assets/img/descarga.png" style="width: 40px; height: 40px;"> EXPORTAR DATOS</button>  
    
  </div>

  <hr>

  <div style="text-align: center;" *ngIf="loading" class="animated fadeIn">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    <hr>
  </div>
  <div *ngIf="dataSourceOpe != null" class="animated fadeIn">
    <mat-form-field>
      <mat-label>Filtro rapido {{ totregistros }} registros</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ingrese algun texto para filtrar">
    </mat-form-field>
    <table mat-table [dataSource]="dataSourceOpe" class="mat-elevation-z8 animated fadeIn">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
    
      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>
    
      <!-- Name Column -->
      <ng-container matColumnDef="cuit">
        <th mat-header-cell *matHeaderCellDef> CUIT </th>
        <td mat-cell *matCellDef="let element"> {{element.cuit}} </td>
      </ng-container>
    
      <!-- Weight Column -->
      <ng-container matColumnDef="empresa">
        <th mat-header-cell *matHeaderCellDef> EMPRESA </th>
        <td mat-cell *matCellDef="let element"> {{element.empresa}} </td>
      </ng-container>
    
      <!-- Symbol Column -->
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> FECHA </th>
        <td mat-cell *matCellDef="let element"> {{element.fecha | date:'dd-MM-yyyy' }} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="importe">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> IMPORTE</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.importe | currency:"$"}} </td>
      </ng-container>
      <!-- Symbol Column -->
      <ng-container matColumnDef="comentario">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> COMENT. ADIC. </th>
        <td mat-cell *matCellDef="let element" style="text-align: center;" (dblclick)="habilitaPedro()"> 
        <p *ngIf="pedro==false">{{element.comentario}}</p> 
        <p *ngIf="pedro==true && element.id ==modifid"><input type="text" value="{{element.comentario}}" [(ngModel)]="comentarioPedro" name="comentarioPedro" >
          <button [disabled]="comentarioPedro =='' || comentarioPedro == null" mat-icon-button color="accent" *ngIf="pedro==true" (click)="actualizarComentario(element.id); habilitaPedro();">
            <mat-icon style="color: forestgreen;" aria-label="Delete">done</mat-icon>
            <i *ngIf="loadingPedro==true" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
          </button>
          <button mat-icon-button color="accent" *ngIf="pedro==true" (click)="habilitaPedro();">
            <mat-icon aria-label="Delete">cancel</mat-icon>
            <i *ngIf="loadingPedro==true"></i>
          </button>
        </p>
        </td>     
      </ng-container>
      <!-- Symbol Column -->
      <ng-container matColumnDef="periodo">
        <th mat-header-cell *matHeaderCellDef> PERIODO </th>
        <td mat-cell *matCellDef="let element"> {{element.periodo}} </td>
      </ng-container>

        <!-- Symbol Column -->
      <ng-container matColumnDef="obs">
        <th mat-header-cell *matHeaderCellDef> OBS </th>
        <td mat-cell *matCellDef="let element"> {{element.obs}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="contacto">
        <th mat-header-cell *matHeaderCellDef> CONTACTO </th>
        <td mat-cell *matCellDef="let element"> {{element.contacto}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="responsable">
        <th mat-header-cell *matHeaderCellDef> RESPONSABLE </th>
        <td mat-cell *matCellDef="let element"> {{element.responsable}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;" style="text-align: center;"> ESTADO </th>
        <td mat-cell *matCellDef="let element" style="text-align: center;"> 
          <p *ngIf="element.estado=='DEUDA'" style="margin-top: 14px; background-color:rgba(255, 70, 70, 0.281); text-align: center;">
            {{element.estado}}
          </p>
          <p *ngIf="element.estado!='DEUDA'" style="text-align: center; margin-top: 15px;">
            {{element.estado}}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="boton">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> ACCION </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">
          <button (click)="calculaHistorico(element.cuit)" id="botonBorraModal" mat-icon-button color="accent" data-toggle="modal" data-target="#MODALHISTORICO">
            <span style="border-radius: 40%; font-size: 10px;" class="btn-primary">&nbsp;{{element.conta}}&nbsp;&nbsp;</span>
            <mat-icon style="color: rgba(0, 132, 255, 0.952);" aria-label="Delete">remove_red_eye</mat-icon>
          </button>
          
          <button *ngIf="role === 'ADMIN' || role === 'DATAENTRY'" [disabled]="false" id="botonBorraModal" mat-icon-button color="accent" data-toggle="modal" data-target="#MODALDATOS">
            <mat-icon style="color: rgba(255, 0, 76, 0.801);" aria-label="Delete">add_circle</mat-icon>
          </button>
          <button *ngIf="userlog == 'matiasmasciotta'" id="botonBorraModal" mat-icon-button color="accent" data-toggle="modal" data-target="#MODALDATOS">
            <mat-icon style="color: rgba(255, 0, 76, 0.801);" aria-label="Delete">add_circle</mat-icon>
          </button>
          <button hidden id="botonBorraModal" mat-icon-button color="accent" (click)="removeAt(element.id)" data-toggle="modal" data-target="#MODALBORRAR">
            <mat-icon aria-label="Delete">delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="selection.toggle(row,id)">
      </tr>
    </table>
  </div>
  <hr>
</div>

<!-- modal historico Large modal -->
<div style="margin-top: 50px;" class="modal fade bd-example-modal-lg" id="MODALDATOS" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg bg-danger">
    <div class="modal-content bg-danger">
      <div class="titulos2" style="text-align: center; margin-top: 5px;">
        <p style="font-weight: bold" class="modal-title" *ngIf="item">ID: {{item[0].id}}&nbsp;"{{item[0].empresa}}"&nbsp;CCT: {{item[0].cct}}&nbsp;- SEC:&nbsp;{{item[0].descripcion}}</p>
      </div>
      
      <div class="modal-body">              
        <app-loading class="m-5" *ngIf="loadingHistorico"></app-loading>           
        <label class="titulos2 "for="obs">&nbsp;Novedad&nbsp;</label>
        <textarea [disabled]="obse==false" type="text" [(ngModel)]="modifobs" name="modifobs" class="form-control" rows="3"></textarea>
        <hr>
        <label class="titulos2 espaciopeque" for="inputAddress">&nbsp;Fecha&nbsp;</label>
        <input [disabled]="obse==false" type="date" [(ngModel)]="fechaparaInsert" name="fechaparaInsert" class="form-control">
        <label class="titulos2 espaciopeque" for="impo">&nbsp;Importe&nbsp;</label>
        <input [disabled]="obse==false" class="form-control" type="number" [(ngModel)]="modifimporte" name="modifimporte">
        <label class="titulos2 espaciopeque" for="pero">&nbsp;Periodo&nbsp;</label>
        <input [disabled]="obse==false" class="form-control" type="text" [(ngModel)]="modifperiodo" name="modifperiodo">
        <label class="titulos2 espaciopeque" for="est" >&nbsp;Estado&nbsp;</label>
        <select [disabled]="obse==false" [(ngModel)]="modifestado" name="modifestado" class="form-control">
          <option value="ACUERDO P/CARGAR">ACUERDO P/CARGAR</option>
          <option value="CONCURSO PREVENTIVO">CONCURSO PREVENTIVO</option>
          <option value="DEUDA">DEUDA</option> 
          <option value="INUBICABLES">INUBICABLES</option>
          <option value="PAGADO">PAGADO</option>
          <option value="SIN EMPLEADO / BAJA">SIN EMPLEADO / BAJA</option>
        </select>
      </div>
      <button *ngIf="obse==false" class="btn btn-success" (click)="habilitaobs()"> <mat-icon aria-label="Delete">edit</mat-icon> Habilitar campos para modificar</button>
      <button *ngIf="obse==true"  class="btn btn-secondary" (click)="habilitaobs()"> <mat-icon style="color: rgba(255, 255, 255, 0.884);" aria-label="Delete">remove_red_eye</mat-icon> Bloquear campos</button>
      <button hidden id="salirmodal" data-dismiss="modal">sale</button>
      <button hidden type="button" class="btn btn-secondary" (click)="updateNovedad(); habilitaobs()"> <i class="fas fa-sign-in-alt"></i>&nbsp;Modificar datos de la novedad <i *ngIf="loadingmodif==true" class="fa fa-spinner fa-spin fa-1x fa-fw"></i></button>
      <button [disabled]="obse==false" type="button" class="btn btn-danger" (click)="insertarNovedad2()"><img src="../../../../assets/img/newww.png" style="width: 40px; height: 40px;"> Insertar Novedad <i *ngIf="loadingNuevaNovedad==true" class="fa fa-spinner fa-spin fa-1x fa-fw"></i></button>
      <button class="btn btn-dark" data-dismiss="modal" id="salirmodal">CANCELAR</button>
    </div>
  </div>
</div>


<!-- Modal VER MAS NOVEDAD O EDITAR (viejo) -->
<div style="margin-top: 100px" class="modal fade rounded" id="MODALDATOS2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div [class]="modalessHeader">
              <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">ID:&nbsp;</p>
              <p style="font-weight: bold" *ngIf="item">{{item[0].id}}&nbsp;"{{item[0].empresa}}"&nbsp;CCT: {{item[0].cct}}&nbsp;- SEC:&nbsp;{{item[0].descripcion}}</p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div [class]="modalessBody" #REPORTE>
              <label for="obs">Novedad</label>
              <textarea [disabled]="obse==false" type="text" [(ngModel)]="modifobs" name="modifobs" class="form-control" rows="3"></textarea>
              <hr>
              <label for="impo">Importe</label>
              <input [disabled]="obse==false" class="form-control" type="number" [(ngModel)]="modifimporte" name="modifimporte">
              <hr>
              <label  for="pero">Periodo</label>
              <input [disabled]="obse==false" class="form-control" type="text" [(ngModel)]="modifperiodo" name="modifperiodo">
              <hr>
              <label  for="est" >Estado</label>
              <select [disabled]="obse==false" [(ngModel)]="modifestado" name="modifestado" class="form-control">
                <option value="ACUERDO P/CARGAR">ACUERDO P/CARGAR</option>
                <option value="CONCURSO PREVENTIVO">CONCURSO PREVENTIVO</option>
                <option value="DEUDA">DEUDA</option> 
                <option value="INUBICABLES">INUBICABLES</option>
                <option value="PAGADO">PAGADO</option>
                <option value="SIN EMPLEADO / BAJA">SIN EMPLEADO / BAJA</option>
              </select>
          </div>
          <button class="btn btn-info" (click)="habilitaobs()"> <mat-icon aria-label="Delete">edit</mat-icon> Habilitar campos para modificar</button>
          <button hidden id="salirmodal" data-dismiss="modal">sale</button>
          <button type="button" class="btn btn-secondary" (click)="updateNovedad(); habilitaobs()"> <i class="fas fa-sign-in-alt"></i>&nbsp;Modificar datos de la novedad   <i *ngIf="loadingmodif==true" class="fa fa-spinner fa-spin fa-1x fa-fw"></i></button>
          <button type="button" class="btn btn-danger"><img src="../../../../assets/img/newww.png" style="width: 40px; height: 40px;"> Insertar Novedad <i *ngIf="loadingmodif==true" class="fa fa-spinner fa-spin fa-1x fa-fw"></i></button>
        </div>
  </div>
</div>

<!-- Modal BORAR NOVEDAD -->
<div style="margin-top: 100px" class="modal fade" id="MODALBORRAR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div class="modal-header">
              <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">¿ELIMINAR NOVEDAD [</p><p *ngIf="item">{{ item[0].id }}]?</p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body" #REPORTE>
              
            <app-loading class="m-5" *ngIf="loading"></app-loading>
            
          </div>
          <button (click)= "borrarNovedad(itemElim)"  
                  type="button" class="btn btn-danger">
            ELIMINAR DEFINITIVAMENTE
          </button>
          <button class="btn btn-dark" data-dismiss="modal" id="salirmodal">CANCELAR</button>
      </div>
  </div>
</div>


<!-- modal historico Large modal -->
<div style="margin-top: 80px;" class="modal fade bd-example-modal-lg" id="MODALHISTORICO" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg bg-dark">
    <div class="modal-content bg-dark">
      <div style="padding: 2px;" class="modal-body">              
        <app-loading class="m-5" *ngIf="loadingHistorico"></app-loading>           
        <table *ngIf="!loadingHistorico" style="width: 100%;" class="table table-dark table-responsive-xl">
          <thead>
            <tr>
              <th class="tdhisto">RAZON</th>
              <th class="tdhisto">ID</th>
              <th class="tdhisto" style="width: 115px;" >FECHA</th>
              <th class="tdhisto">IMPORTE</th>
              <th style="width: 130 px;" class="tdhisto">PERIODO</th>
              <th class="tdhisto" style="width: 100px;">NOVEDAD</th>
              <th class="tdhisto">ESTADO</th>
              <th *ngIf="!permiteEdicion" style="width: 105px;" class="tdhisto">COMENT.</th>              
              <th class="tdhisto">EDITAR</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ope of dataSourceHistorico">
              <td class="thhisto">{{ope.razon}}</td>
              <td class="thhisto">{{ope.id}}</td>
              <td style="width: 115px;" class="thhisto">
                <span >{{ope.fecha | date:'dd-MM-yyyy'}}</span>
                <input *ngIf="permiteEdicion  && ope.id == item[0].id" type="date" style="width: 115px;" [value]="modiffec" [(ngModel)]="modiffec" name="modiffec">
              </td>
              <td class="thhisto">
                <span >{{ope.importe | currency:"$"}}</span>
                <input *ngIf="permiteEdicion && ope.id == item[0].id" type="text" style="width: 70px;" value="{{ope.importe}}" [(ngModel)]="modifimporte" name="modifimporte"> 
              </td>
              <td style="width: 140px;" class="thhisto">
                <span >{{ope.periodo}}</span>
                <textarea *ngIf="permiteEdicion && ope.id == item[0].id" type="text" style="width: 120px;" value="{{ope.periodo}}" rows="3" [(ngModel)]="modifperiodo" name="modifperiodo"></textarea>
              </td>
              <td class="thhisto" style="width: 200px;">
                <span >{{ (ope.obs | slice:0:40) | uppercase }}</span>
                <span *ngIf="!permiteEdicion" id="vermas" data-toggle="popover" title="{{ope.obs | uppercase}}" data-content="FOTO">,&nbsp;<b><i>Ver +..</i></b></span>
                <textarea *ngIf="permiteEdicion && ope.id == item[0].id" type="text" style="width: 200px;" value="{{ope.obs | uppercase}}" rows="4" [(ngModel)]="modifobs" name="modifobs"></textarea>
              </td>
              <td class="thhisto">
                <span>{{ope.estado}}</span>
                <select *ngIf="permiteEdicion && ope.id == item[0].id" style="width: 105px;" value="{{ope.estado}}" id="inputState" class="thhisto" [(ngModel)]="modifestado" name="modifestado">
                  <option value="ACUERDO P/CARGAR">ACUERDO P/CARGAR</option>
                  <option value="CONCURSO PREVENTIVO">CONCURSO PREVENTIVO</option>
                  <option value="DEUDA">DEUDA</option> 
                  <option value="INUBICABLES">INUBICABLES</option>
                  <option value="PAGADO">PAGADO</option>
                  <option value="SIN EMPLEADO / BAJA">SIN EMPLEADO / BAJA</option>
                </select>
              </td>
              <td *ngIf="!permiteEdicion" style="width: 105px;" class="thhisto">
                <span>{{ ope.comentario | slice:0:30 }}</span>
              </td>
              <td style="width: 50px;" class="thhisto" style="text-align: center; color: rgba(255, 255, 255, 0.863); cursor: pointer;">
                <span *ngIf="ope.id == item[0].id && !permiteEdicion">
                  <mat-icon (click)="permitirEdicion()" aria-label="Edit">
                    edit
                  </mat-icon>
                  <i *ngIf="loadingUpdate" class="fa fa-spinner fa-spin fa-1x fa-fw" style="color: rgb(9, 253, 9);"></i>
                </span>
                <span *ngIf="ope.id == item[0].id && permiteEdicion" style="color: red;">
                  <mat-icon (click)="permitirEdicion()" aria-label="CANCELAR">
                    cancel
                  </mat-icon>
                </span>
                &nbsp;
                <span *ngIf="ope.id == item[0].id && permiteEdicion" style="color: green">
                  <mat-icon (click)="permitirEdicion(); updateNovedad();" aria-label="GUARDAR CAMBIOS">
                    done
                  </mat-icon>
                </span>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      
      <button class="btn btn-dark" data-dismiss="modal" id="salirmodal">VOLVER</button>

    </div>
  </div>
</div>

<!-- Modal INSERTAR NUEVA NOVEDAD -->
<div style="margin-top: 100px" class="modal fade" id="MODALINSERTAR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div class="modal-header">
              <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">Nueva Novedad para:  "{{pcuit}}"</p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body" #REPORTE>
              <app-loading class="m-5" *ngIf="loading"></app-loading>
              <form>
                <label for="inputCity">Cuit</label>
                &nbsp;
                <app-cuit-input [(ngModel)]="pcuit" name="pcuit"></app-cuit-input>
                &nbsp;
                <select  [(ngModel)]="pcuit" name="pcuit" id="pcuit" class="form-control">
                  <option *ngFor="let cuits of dataSourceEmpresas" [ngValue]="cuits.cuit">{{ cuits.razon }}</option>
                </select>
                &nbsp;
                <div class="form-group">
                  <label for="inputAddress">Fecha</label>
                  <input type="date" [(ngModel)]="pfecha" name="pfecha" class="form-control">
                </div>
                <div class="form-group">
                  <label for="inputAddress2">Novedad / Observacion</label>
                  <textarea [(ngModel)]="pobs" name="pobs" placeholder="EJ. PAGA LA SEMANA QUE VIENE.." class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="inputCity">Periodo</label>
                    <input type="text" class="form-control" [(ngModel)]="pperiodo" name="pperiodo" placeholder="EJ. MAYO 2019">
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputCity">Importe</label>
                    <input type="number" class="form-control" [(ngModel)]="pimporte" name="pimporte ">
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputState">Estado</label>
                    <select id="inputState" class="form-control" [(ngModel)]="pestado" name="pestado">
                      <option value="ACUERDO P/CARGAR">ACUERDO P/CARGAR</option>
                      <option value="CONCURSO PREVENTIVO">CONCURSO PREVENTIVO</option>
                      <option value="DEUDA">DEUDA</option> 
                      <option value="INUBICABLES">INUBICABLES</option>
                      <option value="PAGADO">PAGADO</option>
                      <option value="SIN EMPLEADO / BAJA">SIN EMPLEADO / BAJA</option>
                    </select>
                  </div>
                </div>
              </form>
          </div>
          <button [disabled]="pcuit == '' || pcuit == null ||
                              pfecha =='' || pfecha == null ||
                              pimporte <= -1 ||
                              pperiodo == '' || pperiodo == null ||
                              pobs == '' || pobs == null ||
                              pestado == '' || pestado == null" 
                  (click)= "insertaNuevo()" id="salemodal" 
                  type="button" class="btn btn-secondary" data-dismiss="modal">
            Añadir novedad
          </button>
      </div>
  </div>
</div>

  